export default __webpack_public_path__ + "static/media/apple-touch-icon.c2e8297f.svg";